import SMOneClickPay from '../../containers/OneClickPay'

export const OneClickPayScreen: React.FC = () => {

  // ======================= VIEWS
  return (
    <>
      <SMOneClickPay />
    </>
  )
}

// ======================= EXPORT
export default OneClickPayScreen
